import React from "react";
import { IQueuedItemToProcess } from "../../../../shared/common/EstimateEngine/EstimateEngineTypes";
import SharedUtils from "../../../../shared/common/SharedUtils";
import { observer } from "mobx-react";
import { MeasurementPanel } from "./Measurements";
import { logDebug } from "../../../../shared/common/logger";

const EstimateRoomHeader: React.FC<{ pageId: string; itemForDebugOnly: IQueuedItemToProcess | null; roomName?: string }> = observer(
	({ pageId, itemForDebugOnly, roomName }) => {
		// logDebug("room name", roomName);
		return (
			<MeasurementPanel
				pageId={pageId}
				itemForDebugOnly={itemForDebugOnly}
				isWizard={false}
				roomName={SharedUtils.capitalizeFirstLetterOfEachWord(
					!roomName?.trim() || roomName?.toLowerCase() === "n/a" ? "Unnamed Room" : roomName
				)}
			/>
		);
	}
);

export default EstimateRoomHeader;
